import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import DashboardHeader from '../../components/dasboardHeader/index.vue'
import SideNav from '../../components/sideNavBar/index.vue'
import CompletedRatingModal from '../../components/CompletedRatingModal'
import JobService from '../../services/jobService'
import { ExportToCsv } from 'export-to-csv'
import 'jspdf-autotable'
const JsPdf = require('jspdf').jsPDF

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      modalActive: false,
      hospitals: [],
      jobs: [],
      constJobs: [],
      timereport: [],
      constreport: [],
      loading: false,
      selected: '',
      selected2: '',
      showMessage: false,
      showMessage2: false,
      showMessage3: false,
      showMessage4: false,
      search1: '',
      search2: '',
      search3: '',
      search4: '',
      sort: false
    }
  },
  components: {
    DashboardHeader,
    SideNav,
    CompletedRatingModal
  },
  mounted () {
    // window.analytics.page('timeApprovalReports')
    window.analytics.identify('timeApprovalReports', {
      path: '/timeApprovalReports'
    })
  },
  async created () {
    this.loading = true
    this.jobs = await JobService.listApplications('FINISHED')
    this.constJobs = this.jobs
    this.hospitals = await JobService.listBranches()
    this.professions = await JobService.listProfessions()
    this.loading = false
    this.timereport = await JobService.timeapprovalreports()
    this.constreport = this.timereport
    console.log(this.constreport)
  },
  methods: {
    uploadModal () {
      this.modalActive = true
      document.body.classList.add('overlay-bg')
    },
    close (bool) {
      if (!bool) this.modalActive = !this.modalActive
      else this.modalActive = null
      document.body.classList.remove('overlay-bg')
    },
    getDate (data) {
      if (data.length === 0) {
        return ''
      }
      const date = parseInt(data)
      const res = Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(new Date(date))
      return res
    },
    professionSearch () {
      // console.log(this.timereport)
      this.timereport = this.constreport
      
      const filteredJobs = this.timereport.filter(job => {
        // console.log(job.user)
        return job.user.toLowerCase().includes(this.search1.toLowerCase())
      })
     
      this.timereport = filteredJobs
      // console.log(filteredJobs)
      // this.search1 = ''
      this.showMessage = false
    },
    departmentSearch () {
      // console.log(this.jobs)
      this.timereport = this.constreport
      const filteredJobs = this.timereport.filter(job => {
        return job.department.toLowerCase().includes(this.search3.toLowerCase())
      })
      this.timereport = filteredJobs
      // this.search1 = ''
      this.showMessage3 = false
    },
    professionalSearch () {
      // console.log(this.jobs)
      this.timereport = this.constreport
      const filteredJobs = this.timereport.filter(job => {
        return job.profession.toLowerCase().includes(this.search2.toLowerCase())
      })
      this.timereport = filteredJobs
      this.showMessage2 = false
    },
    shiftSearch () {
      this.timereport = this.constreport
      const filteredJobs = this.timereport.filter(job => {
        return job.shift.toLowerCase().includes(this.search4.toLowerCase())
      })
      this.timereport = filteredJobs
      this.showMessage4 = false
    },
    // nameSearch () {
    //   this.jobs = this.constJobs
    //   const filteredJobs = this.jobs.filter(job => {
    //     return job.professional.name.full.toLowerCase().includes(this.search4.toLowerCase())
    //   })
    //   this.jobs = filteredJobs
    //   this.showMessage3 = false
    // },
    async reset () {
      await this.$router.push('/upcoming_jobs')
      this.$router.push('/completed_jobs')
    },
    async onChange (event) {
      // this.selected2 = ''
      const hospitalId = event.target.value
      // console.log(event.target.value)
      this.jobs = await JobService.getJobsByProfessions('FINISHED', this.selected2, hospitalId)
      // console.log(this.jobs)
    },
    async onChange2 (event) {
      // this.selected = ''
      const professionId = event.target.value
      this.jobs = await JobService.getJobsByProfessions('FINISHED', professionId, this.selected)
      // console.log(this.jobs)
    },
    convertDate (d) {
      const d1 = new Date(d).toLocaleDateString()
      // console.log(d1)
      var p = d1.split('/')
      return (p[2] + p[1] + p[0])
    },
    sortByDate () {
      const that = this
      var tbody = document.querySelector('.table tbody')
      var rows = [].slice.call(tbody.querySelectorAll('tr'))
      if (!this.sort) {
        rows.sort(function (a, b) {
          return that.convertDate(a.cells[4].innerHTML) - that.convertDate(b.cells[4].innerHTML)
        })
        rows.forEach(function (v) {
          tbody.appendChild(v)
        })
      } else if (this.sort) {
        rows.sort(function (a, b) {
          return that.convertDate(b.cells[4].innerHTML) - that.convertDate(a.cells[4].innerHTML)
        })
        rows.forEach(function (v) {
          tbody.appendChild(v)
        })
      }
      this.sort = !this.sort
    },
    sortId () {
      this.jobs = this.constJobs
      if (!this.sort) {
        const sortedJobs = this.jobs.sort((a, b) => {
          const start = a.job.code.substring(2)
          const end = b.job.code.substring(2)
          return start - end
        })
        this.jobs = sortedJobs
      } else if (this.sort) {
        const sortedJobs = this.jobs.sort((a, b) => {
          const start = a.job.code.substring(2)
          const end = b.job.code.substring(2)
          return end - start
        })
        this.jobs = sortedJobs
      }
      this.sort = !this.sort
    },
    downloadExcel () {
      // console.log('download', this.jobs)
      const convertedData = this.timereport.map(r => {
        return ({ hospital: r.hospital, Location: r.Location, Profession: r.user, Professional_Name: r.profession, Department: r.department, Start_Date: this.getDate(r.date), In_time: this.getDate(r.inTime), Out_time: this.getDate(r.outTime), Check_In_Time: this.getDate(r.checkinTime), Check_Out_Time: this.getDate(r.checkoutTime), Shift: r.shift, Status: r.status, Star_Rating: '', Comments: '', Cost: r.cost })
      })
      // console.log(convertedData)
      const options = {
        filename: `Completed jobs report ${new Date().toDateString().substring(4)}`,
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: false,
        title: 'Completed jobs report',
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true
        // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
      }
     
      const csvExporter = new ExportToCsv(options)
      csvExporter.generateCsv(convertedData)
    },
    downloadPdf () {
      var doc = new JsPdf('p', 'pt')
      const convertedData = this.timereport.map(r => {
        return ({ hospital: r.hospital, Location: r.Location, Profession: r.user, Professional_Name: r.profession, Department: r.department, Start_Date: this.getDate(r.date), In_time: this.getDate(r.inTime), Out_time: this.getDate(r.outTime), Check_In_Time: this.getDate(r.checkinTime), Check_Out_Time: this.getDate(r.checkoutTime), Shift: r.shift, Status: r.status, Cost: r.cost })
      })
      // console.log(result)
      doc.autoTable({
        columnStyles: { overflow: 'linebreak' },
        tableWidth: 'auto',
        horizontalPageBreak: true,
        theme: 'grid',
        body: convertedData,
        columns: [
          { header: 'hospital', dataKey: 'hospital' },
          { header: 'location', dataKey: 'Location' },
          { header: 'profession', dataKey: 'Profession' },
          { header: 'Professional Name', dataKey: 'Professional_Name' },
          { header: 'Department', dataKey: 'Department' },
          { header: 'StartDate', dataKey: 'Start_Date' },
          { header: 'InTime', dataKey: 'In_time' },
          { header: 'OutTime', dataKey: 'Out_time' },
          { header: 'CheckInTime', dataKey: 'Check_In_Time' },
          { header: 'CheckOutTime', dataKey: 'Check_Out_Time' },
          { header: 'Shift', dataKey: 'Shift' },
          { header: 'Status', dataKey: 'Status' },
          { header: 'Cost', dataKey: 'Cost' }
        ]
      })
      doc.save(`Completed jobs report ${new Date().toDateString().substring(4)}`)
    }
  }
}
